// Function to format total amount (assuming cents)
const formatPrice = (amount) => {
	if (!amount) return '$0.00'
	return `$${(amount / 100).toFixed(2)}`
}

export default formatPrice
